import Swiper from 'swiper'
export default (options = {}) => ({
    swiper: null,

    init() {
        const SwiperClass = Swiper
        this.$nextTick(() => {
            this.swiper = new Swiper(this.$refs.slider, {
                spaceBetween: 24,
                watchOverflow: true,
                breakpoints: {
                    0: { slidesPerView: 1.1 },
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: options.perViewDesktop ?? 4 },
                },
            })
        })
    },

    prev() {
        this.swiper && this.swiper.slidePrev()
    },

    next() {
        this.swiper && this.swiper.slideNext()
    },
})
